export default {
  store: {
    DealerCode: '经销商编码',
    DealerName: '经销商名称',
    StoreType: '合作产品',
    StoreCode: '门店编码',
    StoreName: '门店名称',
    Province: '省',
    City: '市',
    Area: '区/县',
    Address: '详细地址',
    Salesman: '客户经理',
    SalesManName: '业务员',
    SalesManId: '业务员Id',
    ModifySalesman: '业务员修改',
    ChooseSalesmanFirst: '请选择业务员',
    Region: '区域',
    ChooseRegionFirst: '请先选择区域',
    Mobile: '联系人手机',
    ChooseStore: '门店选择',
    HaveTheIntention: '有意向',
    NotCooperating: '未合作',
    TerminationOfCooperation: '终止合作',
    Cooperationing: '合作中',
    CouponStatus: '现金券派发状态',
    CanSend: '可派发',
    CanNotSend: '不可派发',
    OnlyOne: '新增门店只能选择一个业务员'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cmc/store.js